import React, { FunctionComponent, ReactNode } from "react";

import { Section } from "../../../ui/Section/Section";
import { SectionHeading } from "./SectionHeading";

type DealerTireDetailsProps = {
  children: ReactNode;
  className?: string;
};

export const Details: FunctionComponent<DealerTireDetailsProps> = ({
  children,
  className,
}) => {
  return (
    <Section>
      <SectionHeading translation="searchResults.partDetails" />
      <div className={className}>{children}</div>
    </Section>
  );
};
